module.exports = __webpack_public_path__ + "img/bb-price.efd0b3c.webp";